module.exports = __webpack_public_path__ + "img/clients2.0d721569.png";